import React from 'react';
import { FaBookOpen, FaFolderOpen, FaChartLine ,FaTrophy } from 'react-icons/fa';
import Header from '../common/Header';
import Footer from '../common/Footer';

const FeaturesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 overflow-x-hidden" dir="rtl">
      {/* Header */}
      <Header />
      
      {/* Features Section */}
      <section id="features" className="relative py-16 sm:py-20 lg:py-28 bg-gray-50 grid-pattern">
        <div className="absolute top-0 left-0 w-96 h-96 bg-primary opacity-5 rounded-full blur-3xl"></div>

        <div className="relative px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div className="grid items-center grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
            <div className="order-2 lg:order-1">
              <div className="relative">
                <img
                  className="relative rounded-2xl shadow-lg w-full"
                  src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2071&q=80"
                  alt="منصة نافس للاختبارات"
                />
                <div className="absolute -bottom-6 -left-6 card-subtle rounded-2xl p-6 shadow-xl">
                  <div className="flex items-center gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-dark-yellow rounded-xl flex items-center justify-center">
                      <FaTrophy className="text-2xl text-white" />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-gray-600">أفضل منصة</p>
                      <p className="text-xl font-bold text-gray-900">2026</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="order-1 lg:order-2">
              <h2 className="text-3xl font-bold leading-tight text-gray-900 sm:text-4xl lg:text-5xl">
                منصة <span className="text-primary">نافس</span> التعليمية
              </h2>
              <p className="mt-6 text-lg leading-8 text-gray-600">
                منصة "نافس" المتخصصة في التقييم والمراجعة الذكية للاختبارات، حيث يتنافس الطلاب في بيئة تعليمية محفزة لتحقيق أفضل النتائج الأكاديمية.
              </p>

              <div className="mt-10 space-y-6">
                {[
                  {
                    icon: <FaBookOpen className="text-xl text-white" />,
                    title: 'مراجعة مرفوعة من الإدارة',
                    description: 'جميع المراجعات متاحة تم رفعها ومراجعتها من قبل إدارة المنصة لتضمن محتوى موثوق ودقيق للطلاب'
                  },
                  {
                    icon: <FaFolderOpen className="text-xl text-white" />,
                    title: 'محتوى شامل ومنظم',
                    description: 'احصل على جميع المراجعات مرتبة بطريقة منظمة لتسهيل عملية الدراسة وتحقيق أفضل النتائج'
                  },
                  {
                    icon: <FaChartLine className="text-xl text-white" />,
                    title: 'تتبع متقدم',
                    description: 'حلل تقدمك الدراسي بمؤشرات أداء دقيقة وتقارير مفصلة عن نقاط القوة والضعف'
                  }
                ].map((feature, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 rounded-xl bg-primary">
                      {feature.icon}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-semibold text-gray-900">{feature.title}</h3>
                      <p className="mt-2 text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex flex-wrap gap-4 mt-10">
                <a href="/tests" className="px-8 py-3 text-white bg-primary rounded-xl font-semibold hover:bg-primary-light transition-all duration-300 shadow-md hover:shadow-lg">
                  ابدأ المراجعة الآن
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />

      <style jsx>{`
        .grid-pattern {
          background-image:
            linear-gradient(rgba(50, 10, 107, 0.02) 1px, transparent 1px),
            linear-gradient(90deg, rgba(50, 10, 107, 0.02) 1px, transparent 1px);
          background-size: 25px 25px;
          background-color: #f9fafb; /* نفس لون bg-gray-50 */
        }

        /* تحسينات للألوان والتباين */
        .text-primary {
          color: #320A6B;
        }

        .bg-primary {
          background-color: #320A6B;
        }

        .border-primary {
          border-color: #320A6B;
        }

        .text-dark-yellow {
          color: #B8860B;
        }

        .bg-dark-yellow {
          background-color: #B8860B;
        }

        /* تحسين التباين للنصوص على الخلفيات الملونة */
        .card-subtle {
          background: rgba(255, 255, 255, 0.95);
          border: 1px solid rgba(0, 0, 0, 0.08);
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }
      `}</style>

      <style jsx global>{`
        body {
          font-family: 'Cairo', sans-serif;
        }

        html {
          scroll-behavior: smooth;
        }

        /* تأكد من أن جميع النصوص مرئية */
        .text-gray-600 {
          color: #4b5563;
        }

        .text-gray-900 {
          color: #111827;
        }

        .text-white {
          color: #ffffff;
        }
      `}</style>
    </div>
  );
};

export default FeaturesPage;